"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleDateLocalizer = void 0;
var configure_1 = __importDefault(require("../configure"));
var date_format_1 = require("../util/date-format");
var date_arithmetic_1 = __importDefault(require("../util/date-arithmetic"));
function simpleDateLocalizer() {
  function endOfDecade(date) {
    date = date_arithmetic_1.default.add(date, 10, 'year');
    date = date_arithmetic_1.default.add(date, -1, 'milliseconds');
    return date;
  }
  function endOfCentury(date) {
    date = date_arithmetic_1.default.add(date, 100, 'year');
    date = date_arithmetic_1.default.add(date, -1, 'milliseconds');
    return date;
  }
  return {
    formats: {
      date: 'L',
      time: 'LT',
      default: 'lll',
      header: 'MMMM YYYY',
      footer: 'LL',
      weekday: 'dd',
      dayOfMonth: 'DD',
      month: 'MMM',
      year: 'YYYY',
      decade: function decade(date, culture, localizer) {
        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
      },
      century: function century(date, culture, localizer) {
        return localizer.format(date, 'YYYY', culture) + ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
      }
    },
    startOfWeek: function startOfWeek() {
      return 0;
    },
    parse: function parse(value) {
      if (!value) {
        return null;
      }
      try {
        return new Date(Date.parse(value));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      return null;
    },
    format: function format(value, _format) {
      return date_format_1.dateFormat(value, _format);
    }
  };
}
exports.simpleDateLocalizer = simpleDateLocalizer;
function default_1() {
  var localizer = simpleDateLocalizer();
  configure_1.default.setDateLocalizer(localizer);
  return localizer;
}
exports.default = default_1;